export enum TipoGrupoDiscussao {
  SalaAula = 'SalaAula',
  TCC = 'TCC'
}

export enum TipoGrupoDiscussaoPorExtenso {
  SalaAula = 'Sala de Aula',
  TCC = 'TCC'
}
